import type { Row } from './db';
import { supabase } from './supabase';

/**
 * Table occupancy (Phase 6, ADR-021): one open session per occupied table, independent of the
 * order lifecycle. Reads only; `table.clear` goes through runCommand.
 */
export type TableSession = Pick<
  Row<'table_session'>,
  | 'id'
  | 'dining_table_id'
  | 'opened_at'
  | 'opened_by'
  | 'opened_by_order_id'
  | 'covers'
  | 'cleared_at'
>;

export const sessionKeys = {
  all: ['table-sessions'] as const,
  open: (locationId: string) => ['table-sessions', 'open', locationId] as const,
};

export async function fetchOpenSessions(locationId: string): Promise<TableSession[]> {
  const { data, error } = await supabase
    .from('table_session')
    .select('id, dining_table_id, opened_at, opened_by, opened_by_order_id, covers, cleared_at')
    .eq('location_id', locationId)
    .is('cleared_at', null)
    .order('opened_at');
  if (error) throw error;
  return data ?? [];
}
